import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { createEntity as createManufacturerAction } from '../../../redux/actions/manufacturersActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

export default function ManufacturerCreate({ open, handleClose }) {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const [manufacturer, setManufacturer] = React.useState('');
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const handleCloseAction = () => {
    setManufacturer('');
    handleClose();
  };

  const onClickSaveEquipmentCategory = async () => {
    const response: any = await dispatch(
      createManufacturerAction({ brand: selectedBrand, name: manufacturer }),
    );
    if (response?.status === 201) {
      dispatch(
        snackbarShowMessage('equipment.success.manufacturerCreateSuccess'),
      );
    }
    handleCloseAction();
    setManufacturer('');
  };

  const onChangeEquipmentCategory = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const capital =
      event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1);
    setManufacturer(capital);
  };

  const manufacturerStrings = {
    id: t('app.common.id'),
    status: t('app.common.status'),
    manufacturer_name: t('createManufacturer.manufacturerName'),
    active: t('app.common.active'),
    inactive: t('app.common.inactive'),
    not_manufacturer_found: t('createManufacturer.noManufacturerFound'),
    create_manufacturer: t('createManufacturer.createManufacturer'),
    edit_manufacturer: t('createManufacturer.editManufacturer'),
    new_manufacturer: t('createManufacturer.newManufacturer'),
    manufacturer: t('createManufacturer.manufacturer'),
    cancel: t('app.common.cancel'),
    add_to_catalog: t('createManufacturer.addToCatalog'),
    activate: t('createManufacturer.activate'),
    inactivate: t('createManufacturer.inactivate'),
    save: t('app.common.save'),
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseAction}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="form-dialog-title">
        {manufacturerStrings.create_manufacturer}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          id="name"
          label={manufacturerStrings.new_manufacturer}
          variant="outlined"
          autoComplete="off"
          size="small"
          value={manufacturer}
          onChange={onChangeEquipmentCategory}
          inputProps={{ maxLength: 100 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {manufacturerStrings.cancel}
        </Button>
        <Button
          onClick={onClickSaveEquipmentCategory}
          fullWidth
          variant="contained"
          color="secondary"
          disabled={manufacturer.length === 0}
        >
          {manufacturerStrings.add_to_catalog}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
